




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import OrderItem from "../../logic/model/OrderItem";
import UserRepository from "../../logic/repository/UserRepository";
import OrderItemMarshaller from "../../logic/model/OrderItemMarshaller";
import PriceItem from "../../logic/model/PriceItem";

@Component({
    name: "order-modal"
})
export default class OrderModal extends Vue {
    @Prop()
    order:any;

    @Prop(Boolean)
    value:Boolean = false;

    name:string="";

    saveOrder() {
        let userRepository = new UserRepository();
        let user = userRepository.findByFullnameOrCreate(this.name);
        let size = this.order.priceItem.$name;
        this.order.article.$prices = [this.order.priceItem];
        let orderItem = new OrderItem(0,user,this.order.article,size,0,false);
        this.$emit('saved',orderItem);
        this.$emit('input', false);

        return;


    }

    private get priceSelectItems() {
        let items:any = [];
        this.order.article.$prices.forEach( (priceItem:PriceItem) => {
            items.push({text: priceItem.$name, value: priceItem})
        });
        return items;
    }

    mounted() {
        this.name = this.$store.state.user.$name
    }

    get calcOrderPrice() {
        return this.order.priceItem.$price.toFixed(2) + "€";
    }

}
